<template>
  <div class="sm:col-span-6">
    <label :for="id" class="block text-sm font-medium text-gray-700 pb-1">{{
      labelText
    }}</label>
    <div class="mt-1 sm:col-span-2 sm:mt-0 relative">
      <input
        :id="id"
        :ref="id"
        :name="id"
        :type="showPassword ? 'text' : type"
        :required="required"
        class="input-primary w-full mb-2"
        :class="[
          !errorMessage
            ? ' shadow-sm focus:border-bkk-100 focus:ring-bkk-100 sm:text-sm'
            : 'border-red-300 border pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500 ',
        ]"
        :placeholder="placeholder"
        @input="validate"
      />
      <div
        class="absolute inset-y-0 right-0 pr-5 pb-2 flex items-center text-sm leading-5"
        @click="showPassword = !showPassword"
      >
        <EyeIcon
          v-if="showPassword"
          class="w-6 h-6 stroke-mid-gray cursor-pointer"
        />
        <EyeCrossedIcon
          v-if="!showPassword"
          class="w-6 h-6 stroke-mid-gray cursor-pointer"
        />
      </div>
      <div
        v-if="errorMessage"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-12 pb-2"
      >
        <ExclamationCircleIcon
          class="h-5 w-5 text-red-500"
          aria-hidden="true"
        />
      </div>
    </div>
    <p v-if="errorMessage" class="mt-2 text-sm text-action-red">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { ExclamationCircleIcon } from "@heroicons/vue/solid";
import EyeIcon from "../icon/EyeIcon.vue";
import EyeCrossedIcon from "../icon/EyeCrossedIcon.vue";

export default {
  name: "PasswordElement",
  components: {
    EyeCrossedIcon,
    EyeIcon,
    ExclamationCircleIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    validation: {
      type: Function,
      default: (password) => {
        const regex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        return password.length <= 3 || regex.test(password);
      },
    },
    errorMessage: {
      type: String,
      default: "",
    },
    errorKey: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "update-field"],
  data() {
    return {
      error: false,
      errorMatching: false,
      showPassword: false,
    };
  },
  computed: {
    labelText() {
      return `${this.label} ${this.required ? "*" : ""}`;
    },
  },
  mounted() {
    this.error = this.errorMessage;
  },
  methods: {
    validate(event) {
      this.$emit("update-field", event.target.value);
    },
  },
};
</script>
